/**
 * Handles all responsive
 * @module responsive
 */

import $ from 'jquery';
import breaky from 'breaky';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'responsive';
export const DEFAULTS = {
  tablet: '',
  desktop: '',
  aboveTablet: '',
  belowMobile: '',
  onTablet: () => {},
  onDesktop: () => {},
  onAboveTablet: () => {},
  onBelowMobile: () => {},
};
/**
 * Set breaky
 * @param  {jQuery} $el - the moving element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setBreaky = ($el, options = {}) => {
  const $tabletPlaceholder = $(options.tablet);
  const $desktopPlaceholder = $(options.desktop);
  const $belowMobilePlaceholder = $(options.belowMobile);
  const $aboveTabletPlaceholder = $(options.aboveTablet);
  breaky.below('mobile', () => {
    $belowMobilePlaceholder.append($el);
  });
  breaky.below('tablet', () => {
    $tabletPlaceholder.append($el);
  });
  breaky.above('tablet', () => {
    $aboveTabletPlaceholder.append($el);
  });
  breaky.above('small-desktop', () => {
    $desktopPlaceholder.append($el);
  });
};
/**
 * Initializes responsive.
 * @param {HTMLElement} el - button /element that opens responsive
 * @param {Object} options - Options used for wiring up the responsive
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function responsive(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setBreaky($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, responsive);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/responsive.js